import { FETCH_ALL_ROLES } from "../../constants";

export default function (state = [], action) {
  switch(action.type){
    case FETCH_ALL_ROLES:
      return action.roles;
    default:
      return state;
  }
}